import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToExistingGroupComponent } from './to-existing-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressInputModule } from '@schoolbelle/api/address-input';

@NgModule({
  declarations: [ToExistingGroupComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,

    AddressInputModule.forRoot(),
  ],
  exports: [ToExistingGroupComponent],
})
export class ToExistingGroupModule { }
